import actionTypes from 'redux/actions/actionTypes'
import flipgridRoles from 'helpers/enums/flipgridRoles'

const defaultState = {
	entityUid: '',
	teacherUrl: '',
	studentUrl: '',
}

function initialize(state, action) {
	return {
		...state,
		entityUid: action.flipgridUID,
	}
}

function initializeSuccess(state, action) {
	return {
		...state,
		teacherUrl: action.data.teacherUrl,
		studentUrl: action.data.studentUrl,
	}
}

function updateInput(state, action) {
	return {
		...state,
		teacherUrl: action.role === flipgridRoles.TEACHER ? action.value : state.teacherUrl,
		studentUrl: action.role === flipgridRoles.STUDENT ? action.value : state.studentUrl,
	}
}

const flipgridReducer = (state = defaultState, action) => {
	switch (action.type) {
		case actionTypes.FLIPGRID_CREATION_TOOL_INITIALIZE:
		case actionTypes.FLIPGRID_INITIALIZE_STANDALONE:
		{
			return initialize(state, action)
		}
		case actionTypes.FLIPGRID_CREATION_TOOL_INITIALIZE_SUCCESS: {
			return initializeSuccess(state, action)
		}
		case actionTypes.FLIPGRID_CREATION_TOOL_UPDATE_INPUT: {
			return updateInput(state, action)
		}
		default: return state
	}
}
export default flipgridReducer
